import { createAsyncThunk } from "@reduxjs/toolkit"
import { practiceLoaderSlice } from "./loader"
import { DataStatus } from "../../enums"
import { apiService } from "../../../features/shared/apiService"
import { RootState } from "../../../reduxStore/store"
import { Practice, PracticeAffiliate } from "../schema"
import { cloneDeep } from "lodash"
import { practiceSlice } from "../model"
import { selectUserCanAccessPracticeAffiliates } from "../../Account/userSlice"
import { fetchPracticeAffiliatesData } from "../../Profile/model"
import { ProviderStatusDisplayIdEnum } from "../../Provider/schema"

export const getPracticeAffiliates = createAsyncThunk(
  "practiceProfile/practiceAffiliates/getPracticeAffiliates",
  async (practiceId: string, { dispatch, getState }) => {
    dispatch(
      practiceLoaderSlice.actions.practiceDataStatusUpdated({
        practiceAffiliatesDataStatus: DataStatus.LOADING,
      }),
    )

    const rootState = getState() as RootState
    const canUserMakeCall =
      selectUserCanAccessPracticeAffiliates(practiceId)(rootState)

    try {
      if (canUserMakeCall) {
        const practiceAffiliates: PracticeAffiliate[] =
          await apiService.practice.get.PRACTICE_AFFILIATES({
            practiceId,
          })

        // Fetch provider data for all affiliates with provider role
        const providersInfo = (
          await fetchPracticeAffiliatesData(practiceAffiliates ?? [])
        ).filter(
          (provider) =>
            provider.providerStatusDisplayId ===
            ProviderStatusDisplayIdEnum.ACTIVE,
        )

        const state = getState() as RootState
        const updatedPractice: Practice = cloneDeep({
          ...state.practice.practice,
          practiceAffiliates,
          providersInfo,
        })
        dispatch(practiceSlice.actions.practiceUpdated(updatedPractice))
      }

      dispatch(
        practiceLoaderSlice.actions.practiceDataStatusUpdated({
          practiceAffiliatesDataStatus: DataStatus.LOADED,
        }),
      )
    } catch {
      dispatch(
        practiceLoaderSlice.actions.practiceDataStatusUpdated({
          practiceAffiliatesDataStatus: DataStatus.ERROR,
        }),
      )
    }
  },
)
